import { render } from "./MenuTop.vue?vue&type=template&id=53123fc8&scoped=true"
import script from "./MenuTop.vue?vue&type=script&lang=js"
export * from "./MenuTop.vue?vue&type=script&lang=js"

import "./MenuTop.vue?vue&type=style&index=0&id=53123fc8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53123fc8"]])

export default __exports__